var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-item-wrapper pt-5 pb-5",on:{"click":_vm.onclick}},[_c('i',{staticClass:"info-item-icon iconfont",domProps:{"innerHTML":_vm._s(_vm.iconfont)}}),_c('label',{staticClass:"item-title info-item-title"},[_vm._v(_vm._s(_vm.title))]),_c('i',{staticClass:"indicator iconfont"},[_vm._v("")])])
}
var staticRenderFns = []

export { render, staticRenderFns }